import React, { Component, PropTypes } from 'react';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';
import Loader from 'components/Material/Loader';

const myContext = (function() {
  let cells,
    document = [],
    window = [],
    navigator = [];

  function test() {
    alert('Baams!');
    console.log('Baams:', cells);
    return 'OK!';
  }

  function addd(a, b) {
    console.log(a + b);
  }

  function _x_sync(vars) {
    if (vars) for (let i = 0; i < vars.length; i++) {}
  }

  function _x_run(remoteCells, code) {
    cells = remoteCells;
    return eval(code);
  }

  return {
    _x_run,
    _x_sync
  };
})();

export default class Spreadsheet extends PageModule {
  static readable = 'Spreadsheet';
  static icon = 'ImageViewComfy';
  static type = 1004;
  static public = false;
  static active = true;

  constructor() {
    super(...arguments);
    const colConfig = [
      /*{width:'80px'},{width:'50px'}*/
    ];
    const focused = [0, 0]; // x,y
    const { params } = this.props;
    const cells = params.cells || [
      ['', '', '', '', '', ''],
      ['', '', '', '', '', ''],
      ['', '', '', '', '', ''],
      ['', '', '', '', '', ''],
      ['', '', '', '', '', '']
    ];

    // push column names
    cells.unshift([]);
    cells[0].push('');

    for (let x = 0; x < cells[1].length; x++) {
      cells[0].push(String.fromCharCode('A'.charCodeAt(0) + x));
    }

    // push row names
    for (let y = 0; y < cells.length; y++) {
      for (let x = 0; x < cells[y].length; x++) {
        if (!x && y) {
          cells[y].unshift(y);
        }
      }
    }

    const shownCells = cells.map(row => {
      return row.map(cell => {
        return this.compute(cell + '');
      });
    });

    this.state = {
      cells,
      shownCells,
      colConfig,
      focused
    };
  }

  getModuleData(moduleData) {
    const cells = this.state.cells;

    // cut headers
    for (let y = 0; y < cells.length; y++) {
      for (let x = 0; x < cells[y].length; x++) {
        if (!x) {
          cells[y].shift();
        }
      }
    }
    cells.shift();

    return {
      cells: cells
    };
  }

  onChangeCell(x, y, e) {
    const cells = this.state.cells.slice();
    const shownCells = this.state.shownCells.slice();
    const { value } = e.target;
    let w = cells[0].length,
      h = cells.length;
    cells[y][x] = value;

    // check if it's a border cell
    if (y == h - 1) {
      // add a row
      let row = [];
      for (let xi = 0; xi < w; xi++) {
        row.push(xi ? '' : h);
      }
      cells.push(row);
      row = row.slice();
      shownCells.push(row);
      h++;
    }

    if (x == w - 1) {
      // add a column
      for (let yi = 0; yi < h; yi++) {
        let symbol = String.fromCharCode('A'.charCodeAt(0) + w);
        cells[yi].push(yi ? '' : symbol);
        shownCells[yi].push(yi ? '' : symbol);
      }

      w++;
    }

    this.setState({ cells, shownCells });
  }

  onFocusCell(x, y) {
    let { cells, shownCells } = this.state;
    shownCells[y][x] = cells[y][x] + '';
    this.setState({ shownCells });
  }

  onFocusOutCell(x, y) {
    let { cells, shownCells } = this.state;
    shownCells[y][x] = this.compute(cells[y][x]);
    this.setState({ shownCells });
  }

  setFocus(x, y) {
    this.setState({ focused: [x, y] });
  }

  compute(value) {
    const { shownCells } = this.state;
    if (value.charAt(0) == '=') {
      return myContext._x_run(shownCells, value.substring(1));
    } else {
      return isNaN(parseFloat(value)) ? value : parseFloat(value);
    }
  }

  renderDetailMode(data) {
    return this.prepareRender(data, false);
  }

  renderEditMode(data) {
    return this.prepareRender(data, true);
  }

  prepareRender(data, canEdit) {
    let { cells, shownCells, colConfig, focused } = this.state,
      styles;

    const rows = shownCells.map((row, rowIndex) => {
      return (
        <tr key={rowIndex}>
          {row.map((cell, cellIndex) => {
            styles = { border: '1px solid #888', padding: '1px 3px' };
            if (!rowIndex) {
              Object.assign(styles, {
                backgroundColor: '#ccc',
                textAlign: 'center'
              });
            } else {
              if (!cellIndex) {
                Object.assign(styles, { backgroundColor: '#ccc' });
              } else {
                let cellWidth = 50;
                if (typeof colConfig[cellIndex - 1] != 'undefined') {
                  cellWidth = colConfig[cellIndex - 1].width;
                }
                Object.assign(styles, {
                  width: cellWidth,
                  backgroundColor: 'white'
                });
              }
            }

            const canEditCell = rowIndex && cellIndex,
              ref = 'ci_' + cellIndex + '_' + rowIndex;

            if (canEditCell) {
              if (
                focused[0] == cellIndex &&
                focused[1] == rowIndex &&
                canEdit
              ) {
                Object.assign(styles, {
                  border: '1px double blue',
                  padding: '0 2px'
                });

                if (this.refs[ref] === document.activeElement) {
                  cell = cells[rowIndex][cellIndex];
                  Object.assign(styles, { borderColor: 'red' });
                }

                return (
                  <td key={cellIndex} style={styles}>
                    <input
                      ref={ref}
                      style={{
                        border: 'none',
                        width: '100%',
                        backgroundColor: 'transparent'
                      }}
                      value={cell}
                      onChange={this.onChangeCell.bind(
                        this,
                        cellIndex,
                        rowIndex
                      )}
                      onFocus={this.onFocusCell.bind(this, cellIndex, rowIndex)}
                      onBlur={this.onFocusOutCell.bind(
                        this,
                        cellIndex,
                        rowIndex
                      )}
                    />
                  </td>
                );
              }
              return (
                <td
                  key={cellIndex}
                  style={styles}
                  onClick={this.setFocus.bind(this, cellIndex, rowIndex)}
                >
                  {cell}
                </td>
              );
            } else {
              // that's a title cell
              return (
                <td key={cellIndex} style={styles}>
                  {cell}
                </td>
              );
            }
          })}
        </tr>
      );
    });

    return (
      <div>
        <table style={{ border: '1px solid #888', borderCollapse: 'collapse' }}>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }

  componentDidMount() {
    this.keyboardInterceptor = this.keyboardInterceptor.bind(this);
    window.addEventListener('keydown', this.keyboardInterceptor);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keyboardInterceptor);
  }

  keyboardInterceptor(e) {
    let { focused } = this.state;

    const w = this.state.cells[0].length,
      h = this.state.cells.length,
      x = focused[0],
      y = focused[1],
      ref = 'ci_' + x + '_' + y,
      active = this.refs[ref] == document.activeElement;

    if (focused[0]) {
      switch (e.keyCode) {
        case 37:
          if (x > 1 && !active) focused[0]--;
          this.setState({ focused });
          break;

        case 38:
          if (y > 1 && !active) focused[1]--;
          this.setState({ focused });
          break;

        case 39:
          if (x < w - 1 && !active) focused[0]++;
          this.setState({ focused });
          break;

        case 40:
          if (y < h - 1 && !active) focused[1]++;
          this.setState({ focused });
          break;

        case 13:
          if (active) {
            this.refs[ref].blur();
          } else {
            window.setTimeout(() => {
              this.refs[ref].focus();
            }, 1);
          }
          break;

        case 27:
          /*  if (active) {
          let {shownCells, cells, lastValue} = this.state;
          cells[y][x] = lastValue;
          shownCells[y][x] = cells[y][x];
          this.setState({shownCells, cells});
        }
        this.setState({focused:[0,0]});*/
          break;

        default:
      }

      e.stopPropagation();
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/plugins/PageModules/Spreadsheet.js